import { NgModule } from '@angular/core';
import { LocaltimeCardComponent } from './localtime-card.component';
import { LocalTimeCardService } from './localtime-card.service';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { AsyncTextModule } from '../async-text/async-text.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatInputModule,
    MatDividerModule,
    AsyncTextModule,
    TranslateModule,
    RouterModule,
  ],
  declarations: [LocaltimeCardComponent],
  exports: [LocaltimeCardComponent],
  providers: [LocalTimeCardService],
})
export class LocalTimeCardModule {}
